import type { ProductSelectionParams } from '../types/product_selection'

/**
 * Reads product selection query params (?size=X&inseam=Y) from a URL.
 * Falls back to the current window location when no URL is provided.
 */
export function getSelectionFromUrl(url?: string): ProductSelectionParams {
  const searchParams = new URL(
    url ?? window.location.href,
    window.location.origin,
  ).searchParams

  return {
    size: searchParams.get('size'),
    inseam: searchParams.get('inseam'),
  }
}
